@if (title) {
  <div class="row mt-2">
    <div class="col">
      <h2>{{ title }}</h2>
    </div>
  </div>
}

@if (documents && documents.length > 0 && !showBottom) {
  <div class="row mt-2">
    <div class="col">
      @if (!singleFileOnly) {
        <table class="grid-table">
          <tr>
            <th>{{ 'Common.Upload.FileName' | translate }}</th>
            <th class="icon-column"></th>
          </tr>
          @for (document of documents; track document) {
            <tr>
              <td>{{ document.filename }}</td>
              <td class="text-right icon-column">
                @if (document.id) {
                  <mat-icon color="primary" (click)="downloadDocument(document)"
                  class="cursorpointer">cloud_download</mat-icon>
                }
                @if (canEdit) {
                  <mat-icon color="primary" (click)="removeDocument(document)" class="ms-3 cursorpointer">
                    delete
                  </mat-icon>
                }
              </td>
            </tr>
          }
        </table>
      }
      @if (singleFileOnly) {
        <div>
          @for (document of documents; track document) {
            <div class="row">
              <div class="col">
                <span class="me-4">Hochgeladene Datei: </span>
                @if (document.id) {
                  <a (click)="downloadDocument(document)" class="cursorpointer">{{ document.filename }}</a>
                }
                @if (!document.id) {
                  <span>{{ document.filename }}</span>
                }
                @if (canEdit) {
                  <mat-icon color="primary" (click)="removeDocument(document)" class="ms-2 cursorpointer align-text-bottom">
                    delete
                  </mat-icon>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
}

@if (canEdit) {
  <div class="row mt-2">
    <div class="col">
      <ngx-file-drop [class.disabled-section]="this.disabled ?? false"
        dropZoneLabel="{{ 'Common.Upload.UploadLabel' | translate }}" (onFileDrop)="onDrop($event)"
        dropZoneClassName="dropzone" contentClassName="dropzone-content" [multiple]="multiple ?? false"
        [disabled]="this.disabled ?? false">
        <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
          @if (!disabled) {
            <div (click)="openFileSelector()">
              <mat-icon color="primary">cloud_upload</mat-icon><br />
              {{ 'Common.Upload.UploadLabel' | translate }}
            </div>
          }
          @if (disabled) {
            <div class="disabled-section">
              <mat-icon color="primary">cloud_upload</mat-icon><br />
              {{ 'Common.Upload.UploadLabel' | translate }}
            </div>
          }
        </ng-template>
      </ngx-file-drop>
      @if (allowedFileExtensions) {
        <p>
          {{ 'Common.Upload.AllowedFiles' | translate }} {{ allowedFileExtensions.join(', ') }}
        </p>
      }
    </div>
  </div>
}

@if (fileErrorTranslationCode) {
  <div class="row mt-3">
    <div class="col">
      <mat-error>
        {{ fileErrorTranslationCode | translate:transValue }}
      </mat-error>
    </div>
  </div>
}

@if (documents && documents.length > 0 && showBottom) {
  <div class="row mt-2">
    <div class="col">
      <table class="grid-table">
        <tr>
          <th><b>{{ 'Common.Upload.FileName' | translate }}</b></th>
          <th class="icon-column"></th>
        </tr>
        @for (document of documents; track document) {
          <tr>
            <td class="cell-overflow">{{ document.filename }}</td>
            <td class="text-right icon-column">
              @if (document.id) {
                <mat-icon color="primary" (click)="downloadDocument(document)"
                class="cursorpointer">cloud_download</mat-icon>
              }
              @if (canEdit) {
                <mat-icon color="primary" (click)="removeDocument(document)" class="ms-3 cursorpointer">delete
                </mat-icon>
              }
            </td>
          </tr>
        }
      </table>
    </div>
  </div>
}
